function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M76.36 300.257L225.826 150.79l-.012-.011c19.362-19.158 31.365-45.738 31.365-75.128 0-28.994-11.681-55.253-30.586-74.35L77.127 150.766l.01.01c-19.36 19.16-31.363 45.74-31.363 75.13 0 28.994 11.681 55.253 30.585 74.35M438.116 212.625l-149.48 149.481.009.012c-19.362 19.16-31.365 45.742-31.365 75.134 0 28.997 11.682 55.26 30.587 74.358L437.348 362.13l-.01-.01c19.362-19.161 31.367-45.743 31.367-75.136 0-28.996-11.684-55.259-30.589-74.358M437.248 150.772l-.011-.011c19.355-19.153 31.354-45.724 31.354-75.105 0-28.984-11.678-55.235-30.575-74.327L77.147 362.199l.01.01c-19.354 19.152-31.353 45.724-31.353 75.104 0 28.986 11.678 55.237 30.576 74.328l360.868-360.869"
})));